export class DateOnly {
    constructor(private date: string | Date) {
        if (typeof date === 'string') {
            this.date = new Date(date);
        }
    }

    toJSON(): string {
        const date = this.date as Date;
        return date.toISOString().split('T')[0];
    }
}